// removed by extract-text-webpack-plugin
module.exports = {"header":"_3253mhg6QatxGs8H_3PbCn_0","logoBox":"_3jApETtWbyCYsiGq8LX93I_0","iconBox":"_3mGbq-5QPQZI4byzz32N8m_0","image":"_2IPZKxYjfUo3IPpqSSL1GI_0","title":"kdxIiydyNtmrkaKtKq9-c_0"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"sourceMap":true,"localIdentName":"[hash:base64]_0","importLoaders":true,"modules":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0c82ac48","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/TheHeader/TheHeader.vue
// module id = JR+i
// module chunks = 4